// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"929ad9ca","314":"74033476","382":"41d9aacf","437":"ea42443b","485":"4d9145e7","634":"568ba297","638":"34b6be3f","898":"317252c7"}[chunkId] + ".chunk.js";
};